import {Observable} from 'rxjs';
import {CpmCApiBridge} from '../../../../../src/app/cpmc-api-bridge';
import {CpmCQueryPaginatorConfig, CpmCQueryPaginatorConfigUtils} from '../../cpmc-defines';
import {AllowedQueryParamTypes, QueryParams} from '../../../../../sdk/src/utils/query.utils';
import {CpmCTaskExecutionApiModel} from '../../models/c-customer/cpmc-task-execution.api-model';
import {CpmCTaskApiService} from './cpmc-task.api-service';
import {CpmCJobLogEntryProxyApiModel} from '../../models/c-customer/cpmc-job-log-entry-proxy.api-model';
import {CpmCPaginatedResultAPISchema} from '../../schemas/cpmc-paginated-result.api-schemas';

export type CpmCGetTasksParams = {
    [K in keyof CpmCTaskExecutionApiModel]?: CpmCTaskExecutionApiModel[K] extends AllowedQueryParamTypes
        ? CpmCTaskExecutionApiModel[K]
        : never;
} & {} & QueryParams;

/**
 * Task Execution Api Service
 */
export class CpmCTaskExecutionApiService {
    public static readonly dPaginatorConfig: CpmCQueryPaginatorConfig = {limit: -1, sort: 'created_at', order: -1};
    public static readonly dLogPaginatorConfig: CpmCQueryPaginatorConfig = {limit: -1, sort: 'time', order: 1};

    // ===============================================================
    // ===============================================================

    public static baseUrl(
        inCustomerUUID: string | undefined,
        inServiceRequestUUID: string | undefined,
        inTaskUUID: string | undefined
    ) {
        const taskUUID = CpmCApiBridge.getCurrentTaskUUID();

        return `${CpmCTaskApiService.endpointGet(inCustomerUUID, inServiceRequestUUID, inTaskUUID || taskUUID!)}/execution`;
    }

    // ===============================================================
    // ===============================================================

    public static endpointList(
        inCustomerUUID: string | undefined,
        inServiceRequestUUID: string | undefined,
        inTaskUUID: string | undefined
    ): string {
        return `${CpmCTaskExecutionApiService.baseUrl(inCustomerUUID, inServiceRequestUUID, inTaskUUID)}/list`;
    }
    public static endpointExecutionLogsList(
        inCustomerUUID: string | undefined,
        inServiceRequestUUID: string | undefined,
        inTaskUUID: string | undefined,
        inJobUUID: string
    ): string {
        return `${CpmCTaskExecutionApiService.baseUrl(inCustomerUUID, inServiceRequestUUID, inTaskUUID)}/${inJobUUID}/logs/list`;
    }

    // ===============================================================
    // ===============================================================

    public static getTaskExecutionList(
        taskUUID: string | undefined,
        params: CpmCGetTasksParams = {},
        paginatorConfig: CpmCQueryPaginatorConfig = CpmCTaskExecutionApiService.dPaginatorConfig
    ): Observable<CpmCPaginatedResultAPISchema<CpmCTaskExecutionApiModel>> {
        return CpmCApiBridge.httpGet<CpmCPaginatedResultAPISchema<CpmCTaskExecutionApiModel>>(
            CpmCTaskExecutionApiService.endpointList(undefined, undefined, taskUUID),
            {
                ...(params as QueryParams),
                ...CpmCQueryPaginatorConfigUtils.toQueryParams(paginatorConfig)
            }
        );
    }
    public static getTaskExecutionLogList(
        taskUUID: string | undefined,
        jobUUID: string,
        params: CpmCGetTasksParams = {},
        paginatorConfig: CpmCQueryPaginatorConfig = CpmCTaskExecutionApiService.dLogPaginatorConfig
    ): Observable<CpmCPaginatedResultAPISchema<CpmCJobLogEntryProxyApiModel>> {
        return CpmCApiBridge.httpGet<CpmCPaginatedResultAPISchema<CpmCJobLogEntryProxyApiModel>>(
            CpmCTaskExecutionApiService.endpointExecutionLogsList(undefined, undefined, taskUUID, jobUUID),
            {
                ...(params as QueryParams),
                ...CpmCQueryPaginatorConfigUtils.toQueryParams(paginatorConfig)
            }
        );
    }
}
